import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/components/BootstrapClientAnalytics/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/contexts/Providers/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/assets/styles/tailwind.css");
;
import(/* webpackMode: "eager" */ "/workspace/assets/styles/vars.css");
;
import(/* webpackMode: "eager" */ "/workspace/assets/styles/utils.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@radix-ui/react-progress/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Viewport","Corner","Scrollbar","Thumb"] */ "/workspace/node_modules/@radix-ui/react-scroll-area/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/workspace/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"app/layout.jsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/local/target.css?{\"path\":\"app/layout.jsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../../assets/fonts/degular.woff2\",\"style\":\"normal\",\"weight\":\"800\",\"variable\":\"--font-degular\"}],\"variableName\":\"degular\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/local/target.css?{\"path\":\"app/layout.jsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../../assets/fonts/degular-display.woff2\",\"style\":\"italic\",\"weight\":\"800\",\"variable\":\"--font-degular-display\"}],\"variableName\":\"degularDisplay\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/AgeGateBox/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/AgeGatedPressable/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Alert/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/Autocomplete/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/BackgroundVideo/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/Checkbox/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/DateField/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Dialog/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/HeroUnit/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Meter/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/Modal/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/Newsletter/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/NumberField/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/OverlayProvider/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Popover/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Pressable/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/RadioGroup/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/Select/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Slider/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Switch/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Tabs/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/Textarea/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/TextField/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/components/Tooltip/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/VideoFooter/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/components/VisuallyHidden/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/gn-universe-ui/lib/contexts/AssetsConfig/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/gn-universe-ui/lib/templates/FourOFour/index.jsx");
